import { render, staticRenderFns } from "./wiki-category-form.vue?vue&type=template&id=1be3978c&"
import script from "./wiki-category-form.vue?vue&type=script&lang=ts&"
export * from "./wiki-category-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports